import { Injectable } from '@angular/core';
import { ActivityPack, BlobAccessLevel, Product, SaveTaggedItemData, UploadFileType, UploadType } from '../components/plant-manager/models/plant-manager.model';
import { DynamicCotrolSaveObject } from '../models/dynamicControlObjects.model';
import { Observable } from 'rxjs';
import { DocumentApiService } from 'src/app/services/document-api.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { IdmApiService } from 'src/app/services';
import { PageType } from '../enums/PageType';
import { PlantmanagerService } from '../components/plant-manager/services/plantmanager.service';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { _TaggedItem, activityPacks } from '../components/plant-manager/components/view-joint-item/view-joint-item.component';
import { ParamsApiService } from 'src/app/services/params-api.services';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { DashboardService } from '../components/dashboards/services/dashboard.service';
@Injectable({
    providedIn: 'root',
})
export class IdmsSharedService {
    //For Leak and Exception save
    ArrPlantManagerSaveObj: SaveTaggedItemData[];
    LeakOrExceptionformGroups: UntypedFormGroup[] = [];
    activityPacks;

    constructor(
        private documentApiService: DocumentApiService,
        private router: Router,
        private idmApiService: IdmApiService,
        private plantmanagerServiceser: PlantmanagerService,
        private customToastService: CustomToastService,
        private modelService: NgbModal, // private cd: ChangeDetectorRef
        private ngxUiLoaderService: NgxUiLoaderService,
        private paramsApiService: ParamsApiService,
        private formBuilder: FormBuilder,
        private globalEmittersService: GlobalEmittersService,
        private dashboardService: DashboardService
    ) {
        this.LeakOrExceptionformGroups.push(this.formBuilder.group({}));
        this.LeakOrExceptionformGroups.push(this.formBuilder.group({}));
        this.ArrPlantManagerSaveObj = [
            {
                schemsForm: null,
                CalculationResult: '',
                GroupType: '',
                images: null,
                ImageUrl: null,
                NamePrimaryKey: '',
                NameSecondaryKey: '',
                selectedConnectorChild: null,
                imageKey: '',
                TaggedItemData: null,
                taggedItemType: '',
                schemaVersionId: null,
                Tab: null,
                dateTypeKey: null,
                IsImageChanged: false,
            },
        ];
    }

    convertKeysToLowerCase(obj) {
        if (Array.isArray(obj)) {
            return obj.map((item) => this.convertKeysToLowerCase(item));
        } else if (typeof obj === 'object') {
            const newObj: any = {};
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    newObj[key.toLowerCase()] = this.convertKeysToLowerCase(obj[key]);
                }
            }
            return newObj;
        } else {
            return obj;
        }
    }

    extractGroupData(schemaForm: any, objSave: DynamicCotrolSaveObject) {
        let Datas: string = '';
        let NamePrimary: string;
        let NameSecondary: string;
        let ImageKey: string;
        const schemaFormCopy = _.cloneDeep(schemaForm);

        const processGroupData = (groupData: any) => {
            if (groupData['images'] === '') {
                groupData['images'] = objSave.ImageUrl;
            }
            if (groupData.hasOwnProperty('images') && groupData['images'] === undefined) {
                groupData['images'] = '';
            }
            if (groupData['jointcalculation']) {
                if (objSave.CalculationResult) groupData['jointcalculation'] = objSave.CalculationResult;
                else groupData['jointcalculation'] = '';
            }
            if (objSave.taggedItemType === 'Line') {
                let namePrimary: string = '';
                if (groupData[objSave.NamePrimaryKey]) {
                    groupData[objSave.NamePrimaryKey].forEach((element) => {
                        namePrimary = namePrimary ? namePrimary + '-' + element.value : element.value;
                    });
                }
                NamePrimary = namePrimary;
            } else {
                if (groupData[objSave.NamePrimaryKey]) {
                    NamePrimary = groupData[objSave.NamePrimaryKey];
                }
            }
            if (groupData[objSave.NameSecondaryKey]) {
                NameSecondary = groupData[objSave.NameSecondaryKey];
            }
            if (objSave?.dateTypeKey)
                objSave?.dateTypeKey.forEach((controlName) => {
                    if (groupData[controlName]) {
                        groupData[controlName] = this.isoToJulian(groupData[controlName]);
                    }
                });

            if (groupData[objSave.imageKey] != null && groupData[objSave.imageKey] != undefined) {
                groupData[objSave.imageKey] = objSave.ImageUrl ?? '';
                ImageKey = objSave.ImageUrl ?? '';
            }

            if (objSave.userSelectKey.length) {
                objSave.userSelectKey.forEach((x) => {
                    if (groupData[x]) {
                        groupData[x] = groupData[x].userId;
                    }
                });
            }

            Datas = Datas + JSON.stringify(groupData);
        };

        if (objSave.GroupType === 'section') {
            for (const sectionName in schemaFormCopy) {
                if (schemaFormCopy.hasOwnProperty(sectionName)) {
                    let sectionData: any = schemaFormCopy[sectionName];
                    for (const groupObject of sectionData) {
                        for (const groupName in groupObject) {
                            if (groupObject.hasOwnProperty(groupName)) {
                                const groupData = groupObject[groupName];
                                processGroupData(groupData);
                                if (objSave?.dateTypeKey)
                                    objSave?.dateTypeKey.forEach((controlName) => {
                                        if (groupData[controlName]) {
                                            groupData[controlName] = this.julianToIso(groupData[controlName].value);
                                        }
                                    });
                            }
                        }
                    }
                }
            }
        } else {
            for (const tabKey in schemaFormCopy) {
                if (schemaFormCopy.hasOwnProperty(tabKey)) {
                    const tabData = schemaFormCopy[tabKey];
                    for (const sectionData of tabData) {
                        for (const groupObject of sectionData) {
                            for (const groupName in groupObject) {
                                if (groupObject.hasOwnProperty(groupName)) {
                                    const groupData = groupObject[groupName];

                                    // Process the group data
                                    processGroupData(groupData);

                                    // Convert date and user ID fields
                                    if (objSave?.dateTypeKey)
                                        objSave?.dateTypeKey.forEach((controlName) => {
                                            if (groupData[controlName]) {
                                                groupData[controlName] = this.julianToIso(groupData[controlName]);
                                            }
                                        });
                                }
                            }
                        }
                    }
                }
            }
        }

        return { Datas, NamePrimary, NameSecondary, ImageKey };
    }

    getBlobImageUrl(images): Observable<any> {
        let url: string = '';
        if (images?.length > 0) {
            for (let i = 0; i < images.length; i++) {
                const instanceImage = {
                    file: images.length === 1 ? images[i] : images[i].file,
                    product: Product.iDMS,
                    uploadType: UploadType.Image,
                    uploadFileType: UploadFileType.Photo,
                    accessLevel: BlobAccessLevel.Public,
                    instanceId: localStorage.getItem('currentInstanceId'),
                    organisationId: localStorage.getItem('selectedOrgId'),
                };
                const formData = new FormData();

                for (const key of Object.keys(instanceImage)) {
                    if (key !== 'file') {
                        formData.append(`path[${key}]`, instanceImage[key]);
                    } else if (key === 'file') {
                        formData.append(`${key}`, instanceImage[key]);
                    }
                }

                return this.documentApiService.uploadTaggedItemImage(formData);
            }
        }
    }

    //Index:1 anable confirm button from html
    //Index:2 anable confirm button from html
    enableConfirmWithRouter(Index: number) {
        if (!this.router.url) {
            return false;
        } else {
            let result = false;
            if (
                Index == 1 &&
                this.router.url != '/settings/idms' &&
                this.router.url != '/idms/plantmanager' &&
                !this.router.url.includes('/idms/plantmanagerView') &&
                !this.router.url.includes('/idms/plantmanager/jointdetails')
            )
                result = true;
            if (
                Index == 2 &&
                (this.router.url == '/settings/idms' ||
                    this.router.url == '/idms/plantmanager' ||
                    this.router.url.includes('/idms/plantmanagerView') ||
                    this.router.url.includes('/idms/plantmanager/jointdetails'))
            )
                result = true;

            return result;
        }
    }

    isoToJulian(isoString: string): string {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const OgDate = new Date(`${year}-${month}-${day}T00:00:00Z`);
        const julianDate = OgDate.valueOf() / 86400000 + 2440587.5;
        return julianDate.toFixed(5);
    }

    julianToIso(julianDate: string): Date {
        if (Number.isNaN(+julianDate)) return new Date(julianDate);
        const milliseconds = (+julianDate - 2440587.5) * 86400000;
        const date = new Date(milliseconds);
        return date;
    }

    _extractGroupData(jsonData: any, objSave: any) {
        let Datas: string = '';
        let NamePrimary;
        let ImageKey;

        if (objSave.GroupType == 'section') {
            for (const sectionName in jsonData) {
                if (jsonData.hasOwnProperty(sectionName)) {
                    const sectionData = jsonData[sectionName];
                    for (const groupObject of sectionData) {
                        for (const groupName in groupObject) {
                            if (groupObject.hasOwnProperty(groupName)) {
                                const groupData = groupObject[groupName];
                                if (groupData.hasOwnProperty('images') && objSave.IsImageChanged == true) {
                                    // Field is available in JSON
                                    groupData['images'] = objSave.ImageUrl;
                                }
                                if (groupData.hasOwnProperty('leakloss')) {
                                    // Field is available in JSON
                                    groupData['leakloss'] = groupData['leakloss'].value + ' ' + groupData['leakloss'].unit;
                                }
                                if (groupData.hasOwnProperty('leakrate')) {
                                    // Field is available in JSON
                                    groupData['leakrate'] = groupData['leakrate'].value + ' ' + groupData['leakrate'].unit;
                                }
                                if (objSave?.dateTypeKey)
                                    objSave?.dateTypeKey.forEach((controlName) => {
                                        if (groupData[controlName]) {
                                            groupData[controlName] = this.isoToJulian(groupData[controlName]);
                                        }
                                    });
                                if (groupData[objSave.NamePrimaryKey]) NamePrimary = groupData[objSave.NamePrimaryKey];
                                if (groupData) Datas = Datas + JSON.stringify(groupData);
                                if (objSave?.dateTypeKey)
                                    objSave?.dateTypeKey.forEach((controlName) => {
                                        if (groupData[controlName]) {
                                            groupData[controlName] = this.julianToIso(groupData[controlName]);
                                        }
                                    });
                            }
                        }
                    }
                }
            }
        } else {
            for (const tabKey in jsonData) {
                if (jsonData.hasOwnProperty(tabKey)) {
                    const tabData = jsonData[tabKey];
                    for (const groupArray of tabData) {
                        for (const groupObj of groupArray) {
                            for (const groupKey in groupObj) {
                                if (groupObj.hasOwnProperty(groupKey)) {
                                    const groupData = groupObj[groupKey];
                                    if (groupData.hasOwnProperty('images')) {
                                        // check Field is available in JSON
                                        groupData['images'] = objSave.ImageUrl;
                                    }
                                    if (objSave?.dateTypeKey)
                                        objSave?.dateTypeKey.forEach((controlName) => {
                                            if (groupData[controlName]) {
                                                groupData[controlName] = this.isoToJulian(groupData[controlName]);
                                            }
                                        });
                                    if (groupData[objSave.NamePrimaryKey]) NamePrimary = groupData[objSave.NamePrimaryKey];
                                    Datas = Datas + JSON.stringify(groupData);
                                    // You can store or process the group data as needed here
                                }
                            }
                        }
                    }
                }
            }
        }
        return { Datas, NamePrimary: NamePrimary, ImageKey };
    }

    async SubmitTaggedItem(ObjSave: SaveTaggedItemData) {
        let response;
        if (ObjSave) {
            //   this.plantmanagerServiceser.saveTaggedItems.next(null);
            let images = ObjSave.images;
            let url: string = '';
            if (images?.length > 0) {
                for (let i = 0; i < images.length; i++) {
                    const instanceImage = {
                        file: images[i].file,
                        product: Product.iDMS,
                        uploadType: UploadType.Image,
                        uploadFileType: UploadFileType.Photo,
                        accessLevel: BlobAccessLevel.Private,
                        instanceId: localStorage.getItem('currentInstanceId'),
                        organisationId: localStorage.getItem('selectedOrgId'),
                    };
                    const formData = new FormData();

                    for (const key of Object.keys(instanceImage)) {
                        if (key !== 'file') {
                            formData.append(`path[${key}]`, instanceImage[key]);
                        } else if (key === 'file') {
                            formData.append(`${key}`, instanceImage[key]);
                        }
                    }

                    try {
                        let res = await this.documentApiService.uploadTaggedItemImage(formData).toPromise();

                        if (res.success) {
                            if (res.response) {
                                url = url == '' ? url + res.response.path : url + ',' + res.response.path;
                                ObjSave.ImageUrl = url;
                            } else {
                                ObjSave.ImageUrl = url;
                            }
                        } else {
                            this.customToastService.errorToast(res.message, 'Error');
                            ObjSave.ImageUrl = url;
                        }
                    } catch (e) {
                        this.customToastService.errorToast('Error while upload image', 'Error');
                        ObjSave.ImageUrl = url;
                    }
                }

                response = await this.SaveTaggedItem(ObjSave);
            } else {
                response = this.SaveTaggedItem(ObjSave);
            }
        }
    }

    async SaveTaggedItem(ObjSave: SaveTaggedItemData) {
        this.ngxUiLoaderService.start();
        if (ObjSave.schemsForm) {
            let Datas = this.extractGroupData(ObjSave.schemsForm.value, ObjSave);
            if (ObjSave.TaggedItemData && (ObjSave.PageType == PageType.PlantManagerEdit || ObjSave.PageType == PageType.PlantManagerEditWithLatestSchema)) {
                //To update the data
                let JsonData: any = {
                    taggedItemId: ObjSave.TaggedItemData.taggedItemId,
                    dataContent: Datas.Datas.replace(/}{/g, ','),
                    namePrimary: Datas.NamePrimary,
                    nameSecondary: Datas.NameSecondary,
                    schemaVersionId: ObjSave.schemaVersionId,
                    // activityPacks: this.activityPacks,
                    // "pipeSpecVersionId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    lineNumberFormatId: ObjSave.lineNumberFormatId,
                };

                if (ObjSave.pipeSpecVersionId) {
                    JsonData.pipeSpecVersionId = ObjSave.pipeSpecVersionId;
                }

                let response = await this.idmApiService.updateTaggedItems([JsonData]).toPromise();
                if (!response) {
                    this.customToastService.errorToast('Error while save Connector', 'Error');
                    this.ngxUiLoaderService.stop();
                    //         return null;
                } else {
                    if (response?.success) {
                        if (ObjSave.TaggedItemData.taggedItemType == 'Joint') {
                            let data = this.plantmanagerServiceser.activeTaggedItem;
                            data.namePrimary = Datas.NamePrimary;
                            this.plantmanagerServiceser.updateJointName.next(data);
                        }
                        if (this.plantmanagerServiceser.activeTaggedItem)
                            this.plantmanagerServiceser.UpdateActiveTaggedItem.next(this.plantmanagerServiceser.activeTaggedItem);
                        else this.plantmanagerServiceser.refreshTaggedItemRoot.next(true);
                        if (response?.approvalAction && response?.approvalAction > 0 && response?.approvalAction <= 2) {
                            this.customToastService.successToast(response.message, 'Success');
                        } else {
                            this.customToastService.successToast('Save Success', 'Success');
                        }
                        this.globalEmittersService.selectedTool = null;
                        this.modelService.dismissAll();
                        this.ngxUiLoaderService.stop();
                        if (this.router.url.match(/^\/idms\/plantmanagerView\/([a-f0-9\-]+)$/)) {
                            this.dashboardService.openJointDetailsByTaggedId.next(ObjSave.TaggedItemData.taggedItemId);
                            // this.plantmanagerServiceser.tmpShowFlangeTab = true;
                        }
                    } else {
                        this.customToastService.errorToast(response.message, 'Error');
                        this.ngxUiLoaderService.stop();
                    }
                }
                this.ngxUiLoaderService.stop();
            } else {
                //To create new data
                let JsonData: any = {
                    connectorParentId:
                        ObjSave.PageType == PageType.PlantManagerCopy
                            ? ObjSave.TaggedItemData.connectorParentId
                            : ObjSave.selectedConnectorChild.connectorParentId,
                    dataContent: Datas.Datas.replace(/}{/g, ','),
                    namePrimary: Datas.NamePrimary,
                    nameSecondary: Datas.NameSecondary,
                    schemaVersionId:
                        ObjSave.PageType == PageType.PlantManagerCopy ? ObjSave.TaggedItemData.schemaVersionId : ObjSave.selectedConnectorChild.schemaVersionId,
                    // "pipeSpecVersionId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                    lineNumberFormatId: ObjSave.lineNumberFormatId,
                };
                if (ObjSave.pipeSpecVersionId) {
                    JsonData.pipeSpecVersionId = ObjSave.pipeSpecVersionId;
                }
                let response = await this.idmApiService.postTaggedItems([JsonData]).toPromise();
                if (!response) {
                    this.ngxUiLoaderService.stop();
                    this.customToastService.errorToast('Error while save Connector', 'Error');
                } else {
                    if (response.success) {
                        this.ngxUiLoaderService.stop();
                        if (response?.approvalAction && response?.approvalAction > 0 && response?.approvalAction <= 2) {
                            this.customToastService.successToast(response.message, 'Success');
                        } else {
                            if (ObjSave.PageType == PageType.PlantManagerCopy) {
                                this.customToastService.successToast('Tagged item copied successfully', 'Success');
                            } else {
                                this.customToastService.successToast('Save Success', 'Success');
                            }
                        }
                        if (this.plantmanagerServiceser.activeTaggedItemForAddChild)
                            this.plantmanagerServiceser.UpdateActiveTaggedItem.next(this.plantmanagerServiceser.activeTaggedItemForAddChild);
                        else if (this.plantmanagerServiceser.activeTaggedItem)
                            this.plantmanagerServiceser.UpdateActiveTaggedItem.next(this.plantmanagerServiceser.activeTaggedItem);
                        else this.plantmanagerServiceser.refreshTaggedItemRoot.next(true);
                        this.globalEmittersService.selectedTool = null;
                        this.modelService.dismissAll();
                    } else {
                        this.ngxUiLoaderService.stop();
                        this.customToastService.errorToast(response.message, 'Error');
                    }
                }
            }
        } else {
            this.ngxUiLoaderService.stop();
        }
    }

    async SubmitLeakAndException(ObjSave: SaveTaggedItemData) {
        if (ObjSave) {
            if (this.ArrPlantManagerSaveObj?.length > 1) {
                if (ObjSave.Tab == 1) {
                    this.ArrPlantManagerSaveObj[0] = ObjSave;
                    this.plantmanagerServiceser.StatusDisabled.next(true);
                } else this.ArrPlantManagerSaveObj[1] = ObjSave;
            } else {
                this.ArrPlantManagerSaveObj.push(ObjSave);
            }
            let images = ObjSave.images;
            let url: string = '';
            if (images?.length > 0 && ObjSave.IsImageChanged) {
                for (let i = 0; i < images.length; i++) {
                    const instanceImage = {
                        file: images[i].file,
                        product: Product.iDMS,
                        uploadType: UploadType.Image,
                        uploadFileType: UploadFileType.Photo,
                        accessLevel: BlobAccessLevel.Private,
                        instanceId: localStorage.getItem('currentInstanceId'),
                        organisationId: localStorage.getItem('selectedOrgId'),
                    };
                    const formData = new FormData();

                    for (const key of Object.keys(instanceImage)) {
                        if (key !== 'file') {
                            formData.append(`path[${key}]`, instanceImage[key]);
                        } else if (key === 'file') {
                            formData.append(`${key}`, instanceImage[key]);
                        }
                    }
                    //, localStorage.getItem('currentInstanceId')
                    this.documentApiService.uploadTaggedItemImage(formData).subscribe(
                        (res: any) => {
                            if (res.success) {
                                if (res.response) {
                                    url = url == '' ? url + res.response.path : url + ',' + res.response.path;
                                    this.ArrPlantManagerSaveObj[1].ImageUrl = url;
                                    // Check if this is the last iteration
                                    if (i === images.length - 1) {
                                        if (ObjSave.Tab == 2) {
                                            this.setActivityPacks(ObjSave);
                                        } else if (
                                            (ObjSave.Tab == 1 &&
                                                ((ObjSave.PageType as PageType) == PageType.EditLeakItem ||
                                                    (ObjSave.PageType as PageType) == PageType.EditExceptionItem)) ||
                                            (ObjSave.PageType as PageType) == PageType.ExceptionEditWithLatestSchema ||
                                            (ObjSave.PageType as PageType) == PageType.LeakEditWithLatestSchema
                                        ) {
                                            this.plantmanagerServiceser.updateForm.next(this.LeakOrExceptionformGroups[1]);
                                        }
                                    }
                                } else {
                                    this.ArrPlantManagerSaveObj[1].ImageUrl = url;
                                    if (ObjSave.Tab == 2) {
                                        this.setActivityPacks(ObjSave);
                                    } else if (
                                        (ObjSave.Tab == 1 &&
                                            ((ObjSave.PageType as PageType) == PageType.EditLeakItem ||
                                                (ObjSave.PageType as PageType) == PageType.EditExceptionItem)) ||
                                        (ObjSave.PageType as PageType) == PageType.ExceptionEditWithLatestSchema ||
                                        (ObjSave.PageType as PageType) == PageType.LeakEditWithLatestSchema
                                    ) {
                                        this.plantmanagerServiceser.updateForm.next(this.LeakOrExceptionformGroups[1]);
                                    }
                                }
                            } else {
                                this.customToastService.errorToast(res.message, 'Error');
                                this.ArrPlantManagerSaveObj[1].ImageUrl = url;
                                if (ObjSave.Tab == 2) {
                                    this.setActivityPacks(ObjSave);
                                } else if (
                                    (ObjSave.Tab == 1 &&
                                        ((ObjSave.PageType as PageType) == PageType.EditLeakItem ||
                                            (ObjSave.PageType as PageType) == PageType.EditExceptionItem)) ||
                                    (ObjSave.PageType as PageType) == PageType.ExceptionEditWithLatestSchema ||
                                    (ObjSave.PageType as PageType) == PageType.LeakEditWithLatestSchema
                                ) {
                                    this.plantmanagerServiceser.updateForm.next(this.LeakOrExceptionformGroups[1]);
                                }
                            }
                        },
                        (error) => {
                            this.customToastService.errorToast('Error while upload image', 'Error');
                            this.ArrPlantManagerSaveObj[1].ImageUrl = url;
                            if (ObjSave.Tab == 2) {
                                this.setActivityPacks(ObjSave);
                            } else if (
                                (ObjSave.Tab == 1 &&
                                    ((ObjSave.PageType as PageType) == PageType.EditLeakItem ||
                                        (ObjSave.PageType as PageType) == PageType.EditExceptionItem)) ||
                                (ObjSave.PageType as PageType) == PageType.ExceptionEditWithLatestSchema ||
                                (ObjSave.PageType as PageType) == PageType.LeakEditWithLatestSchema
                            ) {
                                this.plantmanagerServiceser.updateForm.next(this.LeakOrExceptionformGroups[1]);
                            }
                        }
                    );
                }
            } else {
                if (ObjSave.Tab == 2) {
                    this.setActivityPacks(ObjSave);
                } else if (
                    (ObjSave.Tab == 1 &&
                        ((ObjSave.PageType as PageType) == PageType.EditLeakItem || (ObjSave.PageType as PageType) == PageType.EditExceptionItem)) ||
                    (ObjSave.PageType as PageType) == PageType.ExceptionEditWithLatestSchema ||
                    (ObjSave.PageType as PageType) == PageType.LeakEditWithLatestSchema
                ) {
                    this.plantmanagerServiceser.updateForm.next(this.LeakOrExceptionformGroups[1]);
                }
            }
        }
    }

    setActivityPacks(ObjSave: SaveTaggedItemData) {
        let _taggedItm: _TaggedItem;
        let taggedItemId = this.plantmanagerServiceser?.activeTaggedItem
            ? this.plantmanagerServiceser.activeTaggedItem.taggedItemId
            : ObjSave.TaggedItemData.taggedItemId;
        let extractedData = this._extractGroupData(this.LeakOrExceptionformGroups[0].value, this.ArrPlantManagerSaveObj[0]);
        let dataContent = extractedData.Datas.replace(/}{/g, ','); //remove }{ from string

        let activityPack: activityPacks = {
            namePrimary: extractedData.NamePrimary,
            schemaVersionId: ObjSave.AdditionalInfo.DetailsSchemaVersionId,
            dataContent: dataContent,
            taggedItems: [],
        };
        this.activityPacks = [activityPack];
        let _extractedData = this._extractGroupData(this.LeakOrExceptionformGroups[1].value, this.ArrPlantManagerSaveObj[1]);
        let _dataContent = _extractedData.Datas.replace(/}{/g, ','); //remove }{ from string
        _taggedItm = {
            taggedItemId: taggedItemId,
            activityPackTaggedItemActivity: {
                schemaVersionId: ObjSave.AdditionalInfo.LeakOrExceptionschemaVersionId,
                dataContent: _dataContent,
            },
        };
        if (
            (ObjSave.AdditionalInfo.PageType as PageType) == PageType.EditLeakItem ||
            (ObjSave.AdditionalInfo.PageType as PageType) == PageType.EditExceptionItem ||
            (ObjSave.AdditionalInfo.PageType as PageType) == PageType.LeakEditWithLatestSchema ||
            (ObjSave.AdditionalInfo.PageType as PageType) == PageType.ExceptionEditWithLatestSchema
        ) {
            _taggedItm['activityPackTaggedItemId'] = ObjSave.AdditionalInfo.activityPackTaggedItemId;
            _taggedItm.activityPackTaggedItemActivity['activityPackTaggedItemActivityId'] = ObjSave.AdditionalInfo.activityPackTaggedItemActivityId;
        }
        if (this.activityPacks?.length > 0) {
            if (this.activityPacks[0].taggedItems?.length > 0) {
                JSON.stringify(this.activityPacks[0].taggedItems.find((m) => m.taggedItemId === taggedItemId)) == JSON.stringify(_taggedItm);
            } else {
                this.activityPacks[0].taggedItems.push(_taggedItm);
            }
            if (
                (ObjSave.AdditionalInfo.PageType as PageType) == PageType.AddLeakItem ||
                (ObjSave.AdditionalInfo.PageType as PageType) == PageType.AddExceptionItem
            ) {
                this.ngxUiLoaderService.start();
                this.paramsApiService.postLeakOrException(this.activityPacks).subscribe(
                    (res: any) => {
                        if (res.success) {
                            let SuccessMsg = '';

                            if (res?.message?.trim()) {
                                SuccessMsg = res.message;
                            } else if ((ObjSave.AdditionalInfo.PageType as PageType) == PageType.AddLeakItem) {
                                SuccessMsg = 'Leak created successfully.';
                            } else if ((ObjSave.AdditionalInfo.PageType as PageType) == PageType.AddExceptionItem) {
                                SuccessMsg = 'Exception created successfully.';
                            }

                            this.customToastService.successToast(SuccessMsg, 'Success');
                            let FormData = {
                                schemsForm: ObjSave.schemsForm,
                                Tab: ObjSave.Tab,
                                PlantManagerSaveObj: ObjSave,
                            };
                            this.updateFormException(FormData);
                            if (ObjSave.Tab == 2) {
                                let result = {
                                    activityPacks: null,
                                    Tab: ObjSave.Tab,
                                    PageType: ObjSave.AdditionalInfo.PageType,
                                };
                                this.plantmanagerServiceser.ExceptionOrLeakSaveStatus.next(result);
                            }
                        } else {
                            this.customToastService.errorToast(res.message, 'Error');
                        }
                        // this.plantmanagerServiceser.saveLeakOrException.next(null);
                        this.ngxUiLoaderService.stop();
                    },
                    (error) => {
                        this.ngxUiLoaderService.stop();
                        this.customToastService.errorToast('Unable to create. Please try again or contact administrator', 'Error');
                    }
                );
            } else {
                this.ngxUiLoaderService.start();
                this.activityPacks[0]['activityPackId'] = this.ArrPlantManagerSaveObj[1].AdditionalInfo.activityPackId;
                this.paramsApiService.putLeakOrException(this.activityPacks).subscribe(
                    (res: any) => {
                        if (res.success) {
                            let SuccessMsg = '';

                            if (res?.message?.trim()) {
                                SuccessMsg = res.message;
                            } else if (
                                (ObjSave.AdditionalInfo.PageType as PageType) == PageType.EditLeakItem ||
                                (ObjSave.AdditionalInfo.PageType as PageType) == PageType.LeakEditWithLatestSchema
                            ) {
                                SuccessMsg = 'Leak updated successfully.';
                            } else if (
                                (ObjSave.AdditionalInfo.PageType as PageType) == PageType.EditExceptionItem ||
                                (ObjSave.AdditionalInfo.PageType as PageType) == PageType.ExceptionEditWithLatestSchema
                            ) {
                                SuccessMsg = 'Exception updated successfully.';
                            }

                            this.customToastService.successToast(SuccessMsg, 'Success');
                            let FormData = {
                                schemsForm: ObjSave.schemsForm,
                                Tab: ObjSave.Tab,
                                PlantManagerSaveObj: ObjSave,
                            };
                            this.updateFormException(FormData);
                            let activityPacks: ActivityPack[] = res.response;
                            let result = {
                                activityPacks: activityPacks,
                                Tab: ObjSave.Tab,
                                PageType: ObjSave.AdditionalInfo.PageType,
                            };
                            this.plantmanagerServiceser.ExceptionOrLeakSaveStatus.next(result);
                        } else {
                            this.customToastService.errorToast(res.message, 'Error');
                        }
                        this.ngxUiLoaderService.stop();
                        // this.plantmanagerServiceser.saveLeakOrException.next(null);
                    },
                    (error) => {
                        this.ngxUiLoaderService.stop();
                        this.customToastService.errorToast('Unable to update. Please try again or contact administrator', 'Error');
                    }
                );
            }
        }
    }

    updateFormException(res: any) {
        if (res) {
            let updatedFormGroup: UntypedFormGroup = res.schemsForm;
            if (res.Tab == 1) {
                if (this.ArrPlantManagerSaveObj?.length == 0) {
                    this.ArrPlantManagerSaveObj.push(res.PlantManagerSaveObj);
                } else {
                    this.ArrPlantManagerSaveObj[0] = res.PlantManagerSaveObj;
                }
                this.LeakOrExceptionformGroups[0] = updatedFormGroup;
            }
            if (res.Tab == 2) {
                this.LeakOrExceptionformGroups[1] = updatedFormGroup;
                if (this.ArrPlantManagerSaveObj?.length > 1) {
                    this.ArrPlantManagerSaveObj[1] = res.PlantManagerSaveObj;
                } else {
                    this.ArrPlantManagerSaveObj.push(res.PlantManagerSaveObj);
                }
            }
        }
    }

    formatDateCustom(date: Date): string {
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, '/');
    }
}
